import React from 'react';
import PropTypes from 'prop-types';
import NoResultsHeader from './NoResultsHeader';
import NoResultsIllustration from './NoResultsIllustration';
import NoResultsContent from './NoResultsContent';
import './NoResults.scss';

const NoResults = ({ isNoResults, currentRange, onRangeChange }) => {
	if (!isNoResults) return null;

	return (
		<div className="locations-no-results d-flex flex-column align-items-center justify-content-center text-center p-4">
			<NoResultsHeader />
			<NoResultsIllustration />
			<NoResultsContent
				currentRange={currentRange}
				onRangeChange={onRangeChange}
			/>
		</div>
	);
};

NoResults.propTypes = {
	isNoResults: PropTypes.bool.isRequired,
	currentRange: PropTypes.number,
	onRangeChange: PropTypes.func
};

export default NoResults;
